import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAuth } from "firebase/auth";
import callApi from "../common/APIClient";
import DocumentInfo from "./DocumentInfo";
import { useLocation } from "react-router-dom";

const DocumentDetailPage = () => {
  const { docId } = useParams();
  const location = useLocation();
  const docFromState = location.state?.doc;

  const [selectedDoc, setSelectedDoc] = useState(docFromState);

  useEffect(() => {
    if (!docFromState) {
      const fetchDoc = async () => {
        try {
          const auth = getAuth();
          const user = auth.currentUser;
          if (!user) return;
          const token = await user.getIdToken();
          const response = await callApi({
            url: `/documents/${docId}`,
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setSelectedDoc(response);
        } catch (error) {
          console.error("Error fetching document:", error);
        }
      };

      fetchDoc();
    }
  }, [docId, docFromState]);

  return (
    <div>
      {selectedDoc ? (
        <DocumentInfo selectedDoc={selectedDoc} />
      ) : (
        <p>Loading document...</p>
      )}
    </div>
  );
};


export default DocumentDetailPage;
